import dayjs from "@gtmhub/dayjs";

export const formatDateForPipes = (date: string, format?: string): string => {
  const dayjsDate = dayjs(date);
  if (!dayjsDate.isValid()) {
    return date;
  }

  return format ? dayjsDate.format(format) : dayjsDate.toISOString();
};
